export const countries = [
    { label: 'United States', value: '1' },
    { label: 'Canada', value: '38' },
  ];
  
  export const parseStatesFromHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const options = doc.querySelectorAll('option');
  
    const states = [];
    options.forEach((option) => {
      states.push({
        label: option.textContent,
        value: option.value,
        country: option.getAttribute('ng-if').match(/clientObj\.Country==(\d+)/)[1],
      });
    });
  
    return states;
  };
  
  const data = `<select ng-change="formChanged()" name="state" required title="State" ng-model="clientObj.State" tabindex="-1">
    <!-- Options for US and Canada -->
    <option ng-if="clientObj.Country==1" value="4141">AL (Alabama)</option>
    <option ng-if="clientObj.Country==1" value="4140">AK (Alaska)</option>
    <option ng-if="clientObj.Country==1" value="4143">AZ (Arizona)</option>
    <option ng-if="clientObj.Country==1" value="4142">AR (Arkansas)</option>
    <option ng-if="clientObj.Country==1" value="4144">CA (California)</option>
    <option ng-if="clientObj.Country==1" value="4145">CO (Colorado)</option>
    <option ng-if="clientObj.Country==1" value="4146">CT (Connecticut)</option>
    <option ng-if="clientObj.Country==1" value="4148">DE (Delaware)</option>
    <option ng-if="clientObj.Country==1" value="4147">DC (District of Columbia)</option>
    <option ng-if="clientObj.Country==1" value="4149">FL (Florida)</option>
    <option ng-if="clientObj.Country==1" value="4150">GA (Georgia)</option>
    <option ng-if="clientObj.Country==1" value="4151">HI (Hawaii)</option>
    <option ng-if="clientObj.Country==1" value="4153">ID (Idaho)</option>
    <option ng-if="clientObj.Country==1" value="4154">IL (Illinois)</option>
    <option ng-if="clientObj.Country==1" value="4155">IN (Indiana)</option>
    <option ng-if="clientObj.Country==1" value="4152">IA (Iowa)</option>
    <option ng-if="clientObj.Country==1" value="4156">KS (Kansas)</option>
    <option ng-if="clientObj.Country==1" value="4157">KY (Kentucky)</option>
    <option ng-if="clientObj.Country==1" value="4158">LA (Louisiana)</option>
    <option ng-if="clientObj.Country==1" value="4161">ME (Maine)</option>
    <option ng-if="clientObj.Country==1" value="4160">MD (Maryland)</option>
    <option ng-if="clientObj.Country==1" value="4159">MA (Massachusetts)</option>
    <option ng-if="clientObj.Country==1" value="4162">MI (Michigan)</option>
    <option ng-if="clientObj.Country==1" value="4163">MN (Minnesota)</option>
    <option ng-if="clientObj.Country==1" value="4165">MS (Mississippi)</option>
    <option ng-if="clientObj.Country==1" value="4164">MO (Missouri)</option>
    <option ng-if="clientObj.Country==1" value="4166">MT (Montana)</option>
    <option ng-if="clientObj.Country==1" value="4169">NE (Nebraska)</option>
    <option ng-if="clientObj.Country==1" value="4173">NV (Nevada)</option>
    <option ng-if="clientObj.Country==1" value="4170">NH (New Hampshire)</option>
    <option ng-if="clientObj.Country==1" value="4171">NJ (New Jersey)</option>
    <option ng-if="clientObj.Country==1" value="4172">NM (New Mexico)</option>
    <option ng-if="clientObj.Country==1" value="4174">NY (New York)</option>
    <option ng-if="clientObj.Country==1" value="4167">NC (North Carolina)</option>
    <option ng-if="clientObj.Country==1" value="4168">ND (North Dakota)</option>
    <option ng-if="clientObj.Country==1" value="4175">OH (Ohio)</option>
    <option ng-if="clientObj.Country==1" value="4176">OK (Oklahoma)</option>
    <option ng-if="clientObj.Country==1" value="4177">OR (Oregon)</option>
    <option ng-if="clientObj.Country==1" value="4178">PA (Pennsylvania)</option>
    <option ng-if="clientObj.Country==1" value="4179">RI (Rhode Island)</option>
    <option ng-if="clientObj.Country==1" value="4180">SC (South Carolina)</option>
    <option ng-if="clientObj.Country==1" value="4181">SD (South Dakota)</option>
    <option ng-if="clientObj.Country==1" value="4182">TN (Tennessee)</option>
    <option ng-if="clientObj.Country==1" value="4183">TX (Texas)</option>
    <option ng-if="clientObj.Country==1" value="4184">UT (Utah)</option>
    <option ng-if="clientObj.Country==1" value="4186">VT (Vermont)</option>
    <option ng-if="clientObj.Country==1" value="4185">VA (Virginia)</option>
    <option ng-if="clientObj.Country==1" value="4187">WA (Washington)</option>
    <option ng-if="clientObj.Country==1" value="4189">WV (West Virginia)</option>
    <option ng-if="clientObj.Country==1" value="4188">WI (Wisconsin)</option>
    <option ng-if="clientObj.Country==1" value="4190">WY (Wyoming)</option>
    <!-- canada -->
    <option ng-if="clientObj.Country==38" value="622">Alberta</option>
    <option ng-if="clientObj.Country==38" value="623">British Columbia</option>
    <option ng-if="clientObj.Country==38" value="624">Manitoba</option>
    <option ng-if="clientObj.Country==38" value="625">New Brunswick</option>
    <option ng-if="clientObj.Country==38" value="626">Newfoundland and Labrador</option>
    <option ng-if="clientObj.Country==38" value="627">Northwest Territories</option>
    <option ng-if="clientObj.Country==38" value="628">Nova Scotia</option>
    <option ng-if="clientObj.Country==38" value="629">Nunavut</option>
    <option ng-if="clientObj.Country==38" value="630">Ontario</option>
    <option ng-if="clientObj.Country==38" value="631">Prince Edward Island</option>
    <option ng-if="clientObj.Country==38" value="632">Quebec</option>
    <option ng-if="clientObj.Country==38" value="633">Saskatchewan</option>
    <option ng-if="clientObj.Country==38" value="634">Yukon Territory</option>
  </select>`;
  
  export const allStates = parseStatesFromHTML(data);
  